import type { RecurlyError, TokenPayload } from '@recurly/recurly-js';

type RunThreeDSecureChallengeArgs = {
  actionTokenId: string;
  container: HTMLElement;
};

/**
 * Runs the Recurly.js 3DS challenge and resolves with the action-result token id.
 * Call from a user-initiated gesture (e.g. purchase click) so browsers allow the challenge UI.
 * Configures Recurly if needed — Stripe card checkout may not have configured it yet.
 *
 * https://docs.recurly.com/recurly-subscriptions/docs/3d-secure
 */
export default function runThreeDSecureChallenge({ actionTokenId, container }: RunThreeDSecureChallengeArgs): Promise<string> {
  return new Promise((resolve, reject) => {
    recurly.configure(process.env.NEXT_PUBLIC_RECURLY_KEY);

    const risk = recurly.Risk();
    const threeDSecure = risk.ThreeDSecure({ actionTokenId });

    const cleanup = () => {
      if ('remove' in threeDSecure && typeof threeDSecure.remove === 'function') {
        threeDSecure.remove();
      }
    };

    threeDSecure.on('token', (token: TokenPayload) => {
      cleanup();
      resolve(token.id);
    });

    threeDSecure.on('error', (error: RecurlyError) => {
      cleanup();
      reject(error);
    });

    threeDSecure.attach(container);
  });
}
